import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import InfoBox from './InformationBox'
import InfoWrapper from './InformationBox/InfoWrapper'
import { Container } from './userInfoStyled';
import { MdKeyboardBackspace } from "react-icons/md";
import styled from 'styled-components';
import ReferralCodeDetails from './ReferralCodeDetails';
import AlertModal from 'web/components/AlertModal';
import { AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineVerticalAlignMiddle } from "react-icons/ai";
import { Modal, ModalBody } from 'reactstrap';
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import { BsDownload } from "react-icons/bs";
import { Table } from 'reactstrap';
import MaterialTooltip from "@material-ui/core/Tooltip";
import Pagination from '@material-ui/lab/Pagination';
import ToggleButton from "web/components/ToggleButton";
import SetupCommissionModal from './SetupCommissionModal'
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import xIcon from 'web/assets/images/XIcon.png';
import { getIndividualReferralCodeDetailsApi } from '../../../../../redux/actions/admin';
import { active_commission, get_commission } from "redux/actions/CommissionModule"
import axioPath from 'api/axioPath';

const UserInfo = () => {
  let history = useHistory()
  let location = useLocation();
  const dispatch = useDispatch();

  const token = localStorage.getItem("token");
  const fileUrl = process.env.REACT_APP_API_URL + '/user/image/';
  const [displayLicenseNumber, setDisplayLicenseNumber] = useState(undefined)
  const [page, setPage] = useState('');
  const [pageCount, setPageCount] = useState();
  const [commissionPage, setCommissionPage] = useState(1);
  const [pageNumber, setPageNumber] = useState();
  const [displayPage, setDisplayPage] = useState('userDetails')
  const adminUserInfoDetails = useSelector(state => state.admin.userInfoDetailsAdmin)
  const [referralDetails, setReferralDetails] = useState([])
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const toggleModal = () => setModal(!modal);
  const [noteState, setNote] = useState('')
  const [noteStateUpdated, setNoteUpdated] = useState(false)
  const [noteBtnDisable, setNoteBtnDisable] = useState(false)

  const [commissionModal, SetCommissionModal] = useState(false)
  const [editFlag, setEditFlag] = useState(false)

  let headerArrPromoCode = [
    { title: 'Promo Code', },
    { title: 'Used date ', },
    { title: 'Benefits', },
    { title: 'Status', },
  ]

  let headerArr = [
    { title: 'Contact Name', },
    { title: 'Company Name', },
    { title: 'Email', },
    { title: 'Commission Type', },
    { title: 'Commission Value', },
    { title: 'Order Type', },
    { title: 'Start Date', },
    { title: 'End Date', },
    { title: 'Total Earnings', },
    { title: 'Action', },
  ];
  const [locationResoonse, setLocationResoonse] = useState(false)
  const [locationId, setLocationId] = useState(false)
  useEffect(() => {
    if (location.state !== null && location.state !== undefined) {
      if (location?.state?.items?.accountType === "CORPORATE_ADMIN") {
        setLocationResoonse(location?.state?.items)
        setLocationId(location?.state?.items?.locationId)
        getCommissionList(location?.state?.items?.locationId, commissionPage)
      }
      else {
        setLocationResoonse()
      }
      setPage(location.state.page)
      setPageNumber(location.state?.currentPage && location.state.currentPage)
    } else {
      history.push('/users')
    }
    setNoteUpdated(false)
  }, []);

  const [commissionList, setCommissionList] = useState(false)
  const [commissionListResponse, setCommissionListResponse] = useState(false)
  const [commissionListEdit, setCommissionListEdit] = useState(false)

  const getCommissionList = async (locationId, selectedPage) => {
    let data = {
      locationId: locationId,
      sort: "ASC",
      number: (selectedPage >= 1) ? selectedPage - 1 : 0,
      size: 10
    }
    let response = await dispatch(get_commission(data, token));
    if (response.status === 'SUCCESS') {
      setCommissionList(response?.payload?.list)
      setCommissionListResponse(response?.payload)
      if (response?.payload?.totalElements > 9) {
        setPageCount(response?.payload?.totalPages)
      }
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else if (response?.message !== "Commissions not found.") {
        setModalContent(response?.message);
        toggleModal();
      }
      setCommissionPage()
    }
  }
  useEffect(() => {
    if (adminUserInfoDetails?.notes) setNote(adminUserInfoDetails.notes)
  }, [adminUserInfoDetails])

  const referralCodeClick = async () => {
    let response = await dispatch(getIndividualReferralCodeDetailsApi(adminUserInfoDetails.referralCode));
    if (response.data.status === 'SUCCESS') {
      setReferralDetails(response.data)
      setDisplayPage('referralDetails')
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.data.message);
        toggleModal();
      }
    }
  }
  const licenseImageStyle = {
    display: 'flex',
    position: 'fixed',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9,
    backgroundColor: 'rgb(255 255 255 / 88%)',
  }

  const submitNotes = (e) => {
    e.preventDefault()
    const token = localStorage.getItem('token')
    let email = adminUserInfoDetails.email
    let url = `users/update/usernote?email=${email}&note=${noteState}`
    axioPath.post(url, {}, {
      headers: {
        Authorization: token
      },
    }).then((response) => {
      setNoteUpdated(true)
      setNoteBtnDisable(true)
      setModalContent(response?.data?.status === 'SUCCESS' ? 'Notes successfully updated.' : '')
      setModal(true)
    }).catch((ex) => {
      setModalContent(ex.data?.message ? ex.data?.message : ex.message ? ex.message : 'Issue while updating, please try again.')
      setModal(true)
    });
  }

  const activeCommissionApi = async (id, activeFlag) => {
    let data = {
      id: id,
      active: activeFlag ? false : true
    }
    let response = await dispatch(active_commission(data, token));
    if (response.status === 'SUCCESS') {
      setModalContent(response.message);
      toggleModal();
      getCommissionList(locationId, commissionPage)
    } else {
      if (response?.statusCode === 401) {
        adminLogout()
      } else {
        setModalContent(response.message);
        toggleModal();
      }
    }
  }
  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }

  const handlePageChange = (e, val) => {
    setCommissionPage(val)
    getCommissionList(locationId, val)
  }

  const [filterState, setFilterState] = useState("AFFILIATE")

  const [userFilterState, setUserFilterState] = useState({ sortState: 'normal' })
  const setSortState = (type) => {
    let nextType = ''
    if (type === 'normal') nextType = 'ascend'
    if (type === 'ascend') nextType = 'descend'
    if (type === 'descend') nextType = 'normal'

    if (filterState === "AFFILIATE") {
      setFilterState("INTERNAL")
      let filterData = commissionListResponse?.list.filter(function (item) {
        return (item.commissionType === "AFFILIATE");
      });
      setCommissionList(filterData)
    } else if (filterState === "INTERNAL") {
      setFilterState("")
      let filterData = commissionListResponse?.list.filter(function (item) {
        return (item.commissionType === "INTERNAL");
      });
      setCommissionList(filterData)
    } else {
      setFilterState("AFFILIATE")
      setCommissionList(commissionListResponse?.list)
    }

    setUserFilterState(prevState => ({
      ...prevState,
      sortState: nextType
    }))
  }

  return (
    <div>
      {displayPage === 'userDetails' ?
        <>
          {displayLicenseNumber !== undefined &&
            <div style={licenseImageStyle}>
              <img style={{ position: 'absolute', top: '35px', right: '35px' }} className='xIcon' src={xIcon} alt="X-Icon"
                onClick={() => setDisplayLicenseNumber(undefined)}
              />
              <img
                style={{ pointerEvents: 'none', height: '100%', padding: '50px' }}
                src={`${fileUrl}${adminUserInfoDetails.licenseImage}`} />
            </div>
          }
          <MdKeyboardBackspace style={{ width: '28px', height: '28px', cursor: 'pointer' }}
            onClick={() => {
              if (page === 'dashboard') {
                history.push({
                  pathname: '/admin',
                  state: { page: 'dashboard', noteUpdated: noteStateUpdated }
                })
              } else if (page === 'userManagement') {
                history.push({
                  pathname: '/users',
                  state: { page: 'userManagement', noteUpdated: noteStateUpdated, pageNumber: pageNumber }
                })
              } else if (page === 'userActivity') history.push('./user-activity')

            }} />
          {adminUserInfoDetails && adminUserInfoDetails?.length !== 0 &&
            <Container>
              <InfoBox heading="Main Information">
                <InfoWrapper infoheading="User Name" infodetail={adminUserInfoDetails.userName} />
                <InfoWrapper infoheading="Company Name" infodetail={adminUserInfoDetails.companyName} />
                <InfoWrapper infoheading="DBA" infodetail={adminUserInfoDetails.dbaName} />
                <InfoWrapper infoheading="Email" infodetail={adminUserInfoDetails.email} />
                <InfoWrapper infoheading="Location" infodetail={adminUserInfoDetails.location ? adminUserInfoDetails.location : ''} />
              </InfoBox>
              <InfoBox heading="Account Information">
                <InfoWrapper infoheading="Account Type" infodetail={adminUserInfoDetails.accountType} />
                <InfoWrapper infoheading="User Type" infodetail={adminUserInfoDetails.userType} />
                <InfoWrapper infoheading="Broker" infodetail={adminUserInfoDetails.broker ? 'Yes' : 'No'} />
                <InfoWrapper infoheading="" infoType={page === 'userManagement' ? 'showPalletSupplier' : ''} authId={adminUserInfoDetails?.authId} infodetail={adminUserInfoDetails.isPlalletSupplier} />
              </InfoBox>
              <InfoBox heading="Personal Information">
                {
                  adminUserInfoDetails?.phoneNumber !== null && adminUserInfoDetails?.phoneNumber !== '' &&
                  <InfoWrapper infoheading="Phone Number" infodetail={
                    <p>{adminUserInfoDetails?.phoneNumber}</p>
                  } />
                }
                {
                  adminUserInfoDetails?.licenseNumber?.length > 0 && adminUserInfoDetails?.licenseNumber[0] !== '' &&
                  <InfoWrapper infoheading="License Number" infodetail={
                    <p>{`****${adminUserInfoDetails?.licenseNumber[0].substr(adminUserInfoDetails?.licenseNumber[0].length - 4, adminUserInfoDetails?.licenseNumber[0].length)}`}</p>

                  } />
                }
                {
                  adminUserInfoDetails?.licenseNumber?.length > 0 && adminUserInfoDetails?.licenseNumber[0] !== '' &&
                  <InfoWrapper infoheading="License Image" infodetail={
                    <a title='Download Image' style={{ cursor: 'pointer', padding: '6px 0px' }}><BsDownload
                      style={{ width: '20px', height: '20px' }}
                      onClick={e => setDisplayLicenseNumber(adminUserInfoDetails?.licenseImage)}
                    /></a>
                  } />
                }
                {
                  adminUserInfoDetails?.dnsNumber !== null &&
                  <InfoWrapper infoheading="DNS Number" infodetail={adminUserInfoDetails?.dnsNumber === "" ? 'NA' : adminUserInfoDetails?.dnsNumber} />
                }
                {
                  adminUserInfoDetails.taxId !== null &&
                  <InfoWrapper infoheading="Tax ID" infodetail={adminUserInfoDetails?.taxId} />
                }
                <InfoWrapper infoheading="Business URL" infodetail={adminUserInfoDetails?.webUrl === "https://www.delanceympdefaulturl.com/" ? 'NA' : adminUserInfoDetails?.webUrl} />
              </InfoBox>
              <BusinessDescription>
                <InfoBox heading="Business Description">
                  <InfoWrapper infodetail={adminUserInfoDetails.description ? adminUserInfoDetails.description : "NA"} />
                </InfoBox>
              </BusinessDescription>
              <BusinessDescription>
                <InfoBox heading="Diverse Spend Tracking">
                  <div>
                    {(adminUserInfoDetails.diverseTrackingResponse && adminUserInfoDetails.diverseTrackingResponse?.length > 0) ?
                      <ul style={{ listStyle: 'inside', margin: '17px' }}>
                        {adminUserInfoDetails.diverseTrackingResponse.map((data) => {
                          return <li style={{ marginBottom: '5px' }}>{data.category}</li>
                        })}
                      </ul>
                      :
                      <InfoWrapper infodetail={"NA"} />
                    }
                  </div>
                </InfoBox>
              </BusinessDescription>

              {locationResoonse?.accountType === "CORPORATE_ADMIN" && <CommissionModule>
                <InfoBox heading="Affiliate & Commission Module">
                  {/* <InfoWrapper infodetail={adminUserInfoDetails.description ? adminUserInfoDetails.description : "NA" } /> */}
                  <InputFieldsWrapper>
                    <div style={{ "padding": "15px 15px" }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                        <button className='green-button' onClick={() => {
                          setEditFlag(false)
                          SetCommissionModal(true)
                        }}>
                          <AddPlusIcon />Setup Commission
                        </button>
                      </div>

                      <Table responsive>
                        <thead>
                          <tr>
                            {headerArr.map((items, index) => (
                              <>{index === 3 ?
                                <th className='commission-type-header' key={index} onClick={() => { }}>
                                  {items.title}
                                  {userFilterState.sortState === 'normal' ?
                                    <AiOutlineVerticalAlignMiddle onClick={() => setSortState('normal')} style={{ height: '22px', width: '28px', color: '#61b01f' }} /> :
                                    userFilterState.sortState === 'ascend' ?
                                      <AiOutlineArrowDown onClick={() => setSortState('ascend')} style={{ height: '22px', width: '28px', color: '#61b01f' }} /> :
                                      <AiOutlineArrowUp onClick={() => setSortState('descend')} style={{ height: '22px', width: '28px', color: '#61b01f' }} />}
                                </th> :
                                <th key={index}>
                                  {items.title}
                                </th>
                              }</>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {commissionList && commissionList.map((item, index) => (
                            <tr className='flat-fee-table-data' key={index}>
                              <td className="tooltipWordBreak">
                                <MaterialTooltip
                                  placement="top"
                                  arrow
                                  title={item?.name}
                                  enterTouchDelay={0}
                                >
                                  <a onClick={(e) => { }}>
                                    {item?.name}
                                  </a>
                                </MaterialTooltip>
                              </td>
                              <td className="tooltipWordBreak">
                                {item?.commissionType === "AFFILIATE" ? <MaterialTooltip
                                  placement="top"
                                  arrow
                                  title={item?.companyName}
                                  enterTouchDelay={0}
                                >
                                  <a onClick={(e) => { }}>
                                    {item?.companyName}
                                  </a>
                                </MaterialTooltip> :
                                  <a>NA</a>
                                }
                              </td>
                              <td>{item?.email}</td>
                              <td>{item?.commissionType === "AFFILIATE" ? "Affiliate" : "Internal"}</td>
                              <td>{item?.commissionMode === "FLAT" ? '$' + parseFloat(item?.commissionValue).toFixed(2) : parseFloat(item?.commissionValue).toFixed(3) + '%'}</td>
                              <td>{item?.commissionOrderType}</td>
                              <td>{item?.startDate}</td>
                              <td>{item?.endDate}</td>
                              <td>${parseFloat(item?.totalEarning).toFixed(2)}</td>
                              <td>
                                <div className='toggle-wrapper'>
                                  <ToggleButton flag={item?.active} item={item} callBack={(id, flag) => {
                                    activeCommissionApi(id, flag)
                                  }} />
                                  <div className='editDiv' onClick={() => {
                                    setEditFlag(true)
                                    setCommissionListEdit(item)
                                    SetCommissionModal(true)
                                  }}>
                                    <EditIcon />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {commissionPage && <Pagination
                        count={pageCount}
                        page={commissionPage}
                        onChange={handlePageChange} />}
                    </div>
                  </InputFieldsWrapper>
                </InfoBox>
              </CommissionModule>}
              {location?.state?.page === 'userManagement' &&
                <InfoBox heading="Payment Information">
                  {(adminUserInfoDetails.userType === 'Buyer & Seller' || adminUserInfoDetails.userType === 'Seller') && <InfoWrapper infoheading="Sellers Remittance Information" infodetail={adminUserInfoDetails.paymentDetails.forSelling?.map(val => {
                    return (
                      <div className='payment-info-div'>
                        <p>Name : {val.bankAccount ? val?.bankAccount?.name : val.card?.name}</p>
                        <p>Type : {val.paymentMethod}</p>
                        <p>{val.bankAccount ?
                          `Account No. : ******${val.bankAccount.last4}` :
                          `Card Number : **** **** **** ${val.card.last4Digit} (expires on ${val.card.expMonth}/${val.card.expYear}) (${val.card.brand})`
                        }</p>
                        {val.bankAccount && <p>Routing No. : {val.bankAccount.routingNumber}</p>}
                      </div>
                    )
                  })
                  } />}

                  {(adminUserInfoDetails.userType === 'Buyer & Seller' || adminUserInfoDetails.userType === 'Buyer') && <InfoWrapper
                    infoheading="Buyer Payment Information"
                    infodetail={adminUserInfoDetails.paymentDetails.forBuying?.length > 0 ? (
                      adminUserInfoDetails.paymentDetails.forBuying.map(val => (
                        <div className='payment-info-div' key={val.id}>
                          <p>Name : {val.achBankAccount ? val?.name : val.card?.name}</p>
                          <p>Type : {val.paymentMethod}</p>
                          <p>
                            {val.achBankAccount
                              ? `Account No. : ******${val.achBankAccount.last4}(${val.achBankAccount.isVerified ? 'Verified' : 'Not Verified'})`
                              : `Card Number : **** **** **** ${val.card.last4Digit} (expires on ${val.card.expMonth}/${val.card.expYear}) (${val.card.brand})`}
                          </p>
                          {val.achBankAccount && <p>Routing No. : {val.achBankAccount.routingNumber}</p>}
                        </div>
                      ))
                    ) : (
                      <p>NA</p>
                    )}
                  />}

                  {adminUserInfoDetails?.paymentDetails?.forSubscription?.card && (
                    <InfoWrapper infoheading="Membership Subscription Information" infodetail={
                      <div className='payment-info-div'>
                        <p>Name : {adminUserInfoDetails.paymentDetails.forSubscription.card?.name}</p>
                        <p>Type : {adminUserInfoDetails.paymentDetails.forSubscription.card?.type}</p>
                        <p>Card Number : **** **** **** {adminUserInfoDetails.paymentDetails.forSubscription.card?.last4Digit} ({adminUserInfoDetails.paymentDetails.forSubscription.card?.brand})</p>
                      </div>
                    } />
                  )}
                </InfoBox>}

              <InfoBox heading="Referral Information">
                <InfoWrapper infoheading="Code" infodetail={
                  <>
                    <p
                      style={{ cursor: 'pointer', color: '#00b2fe' }}
                      onClick={referralCodeClick}>{adminUserInfoDetails?.referralCode}</p>
                  </>
                } />
                <InfoWrapper infoheading="Used by (Count)" infodetail={adminUserInfoDetails?.successfullInvites} />
                <InfoWrapper infoheading="Referral discount(s) availed" infodetail={adminUserInfoDetails?.referralDiscountAvailed} />
                <InfoWrapper infoheading="Description" infodetail={adminUserInfoDetails?.referralDescription} />
              </InfoBox>
              <PromoCodeTable className='promo-code-table'>
                <InfoBox heading="Promo Code">
                  {adminUserInfoDetails.promoCode !== null ? (
                    <InfoWrapper className={'full-width'} infodetail={
                      <Table responsive >
                        <thead>
                          <tr>
                            {headerArrPromoCode.map((items, index) => (
                              <th key={index}>{items.title}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {
                            adminUserInfoDetails.promoCode && adminUserInfoDetails.promoCode.map((items, index) => (
                              <tr key={index}>
                                <td>{items.promoCode}</td>
                                <td>{items.usedDate}</td>
                                <td>{`${items.discountType} for ${items.timeSpanForBenefits.number} ${items.timeSpanForBenefits.timeDMY}(s)`}</td>
                                <td>{items.isActive ? 'Active' : 'Inactive'}</td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    } />
                  )
                    :
                    <InfoWrapper infodetail='NA' />
                  }
                </InfoBox>
              </PromoCodeTable>
              {(location?.state?.page === 'dashboard' || location?.state?.page === 'userManagement') &&
                <BusinessDescription>
                  <InfoBox heading="Notes">
                    <InfoWrapper className={'full-width'} infoheading="" infodetail={
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <textarea
                          style={{ minHeight: '100px', padding: '5px', borderRadius: '5px' }}
                          value={noteState}
                          onChange={(e) => {
                            setNote(e.target.value)
                            setNoteBtnDisable(false)
                          }}
                        />
                        <button
                          disabled={noteState === '' || adminUserInfoDetails?.notes === noteState || noteBtnDisable}
                          style={{ width: '68px', marginTop: '10px', alignSelf: 'flex-end', borderRadius: "5px", background: 'rgb(39, 145, 27)', color: 'white', border: 'none', height: '30px', opacity: (noteState === '' || adminUserInfoDetails?.notes === noteState || noteBtnDisable) ? 0.7 : 1 }}
                          onClick={submitNotes}>
                          Submit
                        </button>
                      </div>
                    } />
                  </InfoBox>
                </BusinessDescription>
              }
            </Container>
          }

          {commissionModal && locationResoonse?.accountType === "CORPORATE_ADMIN" && <Modal style={{ maxWidth: "972px" }} size="xl" isOpen={SetCommissionModal} centered={true}>
            <SetupCommissionModalWrapper>
              <ModalBody>
                <SetupCommissionModal locationResoonse={locationResoonse} commissionList={commissionListEdit} editFlag={editFlag} toggle={() => {
                  SetCommissionModal(false)
                  getCommissionList(locationId, commissionPage ? commissionPage : 1)
                }} />
              </ModalBody>
            </SetupCommissionModalWrapper>
          </Modal>}

          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            content={modalContent}
          />
        </>
        :
        <>
          <ReferralCodeDetails
            togglePage={() => setDisplayPage('userDetails')}
            referralDetails={referralDetails}
          />
        </>

      }
    </div>
  )
};

export default UserInfo;

const BusinessDescription = styled.div`
    .full-width{
      width: 100% !important;
    }
    .info-detail-wrapper {
        grid-template-columns: 1fr;
    }
`
const CommissionModule = styled.div`

    .info-detail-wrapper {
        grid-template-columns: 1fr;
        display: block;

       
    }
`
const PromoCodeTable = styled.div`
  &.promo-code-table {
      .table-responsive {
          max-height: 303px;
      }
  }
  .full-width{
    width: 100%
  }
  .info-detail-wrapper {
      grid-template-columns: 1fr;
      /* .info-wrapper-box {
          padding: 0;
          > div {
              margin: 0;
          }
      } */
  }
`
const InputFieldsWrapper = styled.div`
.editDiv{
    cursor: pointer;
}
.commission-type-header {
    cursor: pointer;
    .arrow {
        margin-left: 10px;
    }
    .up-move {
        transform: rotate(180deg);
    }
}
.tooltipWordBreak{
    word-break: break-word;
    /* color: rgb(10, 85, 135); */
    min-width: 125px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* font-size: 20px; */
    max-width: 125px;
    /* width: 100%; */
}
.toggle-wrapper {
    display: inline-flex;
    gap: 5px;
    align-items: center;
    min-width: 111px;

    .label-switch {
        margin: 0;
    }
}
      h6{
        color: #ababab;
        font-size: 11px;
        margin-bottom: 3px;
      }
      h4{
        text-align: center;
        font-weight: bold;
        font-size: 26px;
      }
      h5{
        text-align: center;
        font-size: 14px;
        margin: 17px 0 0 0px;
        max-width: 370px;
      }      
      p{
        color: #ef5657;
        font-size: 11px;
        margin-top: 2px;
      }      
      img{
            top: 4px !important;
            left: 6px !important;
            width: 20px;
            height: 20px;
      }
      input{
        border: none;
        border-bottom: 1px solid #e1e1e1;
        border-radius: 0;
        padding: 0;
      }
      
      .flatType{
          input:disabled {
          background-color: hsl(0,0%,95%) !important;
        }
      }
      .fixed-height{
        position: relative;
        min-height: 72px;
        .height-adjust{
          position: absolute;
          top: 15px;
          width: 90%;
        }
      }
      .date-style{
        border: 1px solid #87cdf1 !important;
        border-radius: 2px !important;
        padding: 0px 20px 0 15px !important;
      }      
      .green-button{
        background: linear-gradient(90deg, #55C416 1.12%, #367910 100%);
        border: none;
        border-radius: 5px;
        height: 30px;
        color: #fff;
        font-size: 14px;
      }
      .bordered-input{
        input{
          border: 1px solid #87cdf1;
          border-radius: 5px;
          padding: 0px 10px 0px 10px;
        }
      }
      .date-border-adjust{
        input{
          border:none;
          /* padding: 5px; */
        }
      }
      .error-styling-input{
        input{
          border: none !important;
          border-bottom: 1px solid #ef5657 !important;
        }
      }
      .table thead th,.table td, .table th {
        font-size: 14px;
      }
      .userlist-header{
        display: flex;
        justify-content: space-between;
        padding: 10px 0 15px 0;
        h1{
          font-size: 16px;
          font-weight: bold;
        }
        img{
          cursor: pointer;
        }
      }
      .app-input-text {
        margin-bottom: 15px !important;
      }  
      .app-input-text input.error {
        border: none !important;
        border-bottom: 1px solid #ef5657 !important;
      }
      .radio-checkmark{
        top: 2.5px !important;
        border: 1px solid #005586 !important;
      }
      .radio-checkmark:after {
        background: #005586 !important;
      }
      .radioField{
        span{
          font-size: 14px;
        }
      }
      .checkbox-field {
            margin: 0 0 0 14px !important;
      }
      .checkbox-container{
          font-size: 14px !important;
      }
      .checkMark {
            border: solid 2px #D5D5D5 !important;
      }

     /* When the checkbox is checked, add a blue background */
      .checkbox-container input:checked ~ .checkMark {
           background: linear-gradient(to bottom, #F7F9FA 0%, #F7F9FA 100%) !important;
      }
      .checkbox-container input:checked ~ .checkMarkDisable:after {
          display: block;
      }
      .checkbox-container .checkMarkDisable:after {
          left: 6px;
          top: 2px;
          width: 6px;
          height: 11px;
          border: solid white;
          border-width: 0 3px 3px 0;
          transform: rotate(45deg);
      }

      .checkMarkDisable:after {
          content: "";
          position: absolute;
          display: none;
      }
      .checkbox-container input:checked ~ .checkMarkDisable {
        position: absolute;
        top: 0;
        left: 0;
        background-color: transparent;
        border-radius: 2px;
        border: solid 2px #979797;
        height: 21px;
        width: 21px;
        background: linear-gradient(to bottom, #979797 0%, #979797 100%);
      }

      
      .checkMarkDisable:after {
      border: solid black !important;
      border-width: 0 3px 3px 0 !important;
      }
      /* Style the checkMark/indicator */
      .checkMark:after {
      border: solid black !important;
      border-width: 0 3px 3px 0 !important;
      }

      .input-disabled{
        .app-input-text{
          input{
            background: #f2f2f2;
          }
        }
      }
      
      .completion-page{
        height: 435px;
        padding: 90px 0 100px 0;
        text-align: center;
        img{
              width: 55px;
              height: 55px;
              margin: 20px;
        }
        .save-button{
          background: #005586;
          padding: 5px;
          width: 68px;
          border-radius: 5px;
          color: #fff;
          border: none;
        }
      }
`;
const SetupCommissionModalWrapper = styled.div`
    .modal-body{
      padding: 0px !important;
    }
    .modal-content{
      border-radius: 0px !important;
    }
    .modal-header-style{
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #e6e6e6;
      border-radius: 0px;
      h6{
        margin: 12px 12px 12px 25px;
        font-weight: bold;
      }
      img{
        margin: 12px 25px 12px 12px;
        height: 20px;
        width: 20px;
        cursor: pointer;
      }
    }
    .modal-content-style{
      display: flex;
      padding: 15px 25px 15px 25px;
      justify-content: space-between;
      input{
        min-width: 404px;
        font-size: 16px;
      }
      input::-webkit-input-placeholder {
        color: #9c9c9c !important;
        font-size: 14px !important;
      }
      .invite-email-style{
        padding: 5px 5px 5px 15px;
        border: 1px solid #DADADF;
        border-radius: 4px;
        width: 75%;
        font-size: 14px;
      }
      .invite-button-disabled{
        margin-left: 10px;
        width: 100px;
        height: 40px;
        background: #F2F2F2;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        font-size: 14px;
      }
      .invite-button{
        margin-left: 10px;
        width: 100px;
        height: 40px;
        background: linear-gradient(180deg, #55C416 0%, #367910 100%);
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        color: #fff;
        cursor: pointer;
      }
      .app-input-text{
        margin-bottom: 15px !important;
      }
    }
    .specfiles-wrapper{
      .check-disabled{
        .radio-checkmark{
          background: grey;
          border: none;
        }
      }
    }
`;